import { yLoadAsyncScript } from './util';

declare global {
    const AppleID: any;
}

export namespace $apple {
    let apple_promise: Promise<void> | undefined;

    export function init() {
        if(!apple_promise) {
            apple_promise = yLoadAsyncScript('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js').then(() => {
                AppleID.auth.init({
                    clientId: 'se.abundolive.web',
                    scope: 'email',
                    redirectURI: 'https://abundolive.se/callback/apple_signin',
                    state: 'signup',
                    usePopup: true
                });
            });
        }

        return apple_promise;
    }

    export function login(): Promise<string> {
        return init().then(() => AppleID.auth.signIn().then((response: any) => response.authorization.id_token));
    }
}
